import GenericLangValue from "./GenericLangValue";
import {assetKeys} from "../config/constants";
import AdmsIdentifier from "./AdmsIdentifier";
import {keys} from "../config/nameSpacesKeys";

export default class Publisher {
  constructor(name, initialValue, namespace, admsNameSpace, notationNameSpace, schemaAgencyNameSpace, agentType) {
    // console.log(name, initialValue, namespace, admsNameSpace, notationNameSpace, schemaAgencyNameSpace, agentType);
    this.namespace=namespace;
    this.admsName=name;
    this.selectedType = agentType || null;
    // this.type = "@type";
    // this.typeValue = agentType || null;
    this.name = new GenericLangValue(name = "name", null, keys.name);
    this.admsNameSpace = admsNameSpace;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.admsList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.createEmptyAdmsObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getName() {
    return this.name;
  }

  setName(nameObj) {
    this.name = nameObj;
  }

  getAdmsIdentifiersList() {
    return this.admsList;
  }

  setAdmsIdentifiersList(fadmsList) {
    this.admsList = fadmsList;
  }

  getType() {
    return this.selectedType;
  }

  setType(type) {
    this.selectedType = type;
  }

  createEmptyAdmsObj() {
    const adms = new AdmsIdentifier(this.admsName, null, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    this.admsList.push(adms);
  }

  createAdmsObj(obj) {
    const adms = new AdmsIdentifier(this.admsName, obj, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    this.admsList.push(adms);
  }

  removeAdmsObj(obj, index) {
    if (index < 0 || index >= this.admsList.length) {
      return false;
    }
    this.admsList.splice(index, 1);
  }

  setAdms(inputObj) {
    const admsObj = inputObj[this.admsNameSpace];
    // console.log(admsObj);
    if (Array.isArray(admsObj)) {
      for (const entry of Object.entries(admsObj)) {
        const value = entry[1];
        this.createAdmsObj(value);
      }
    } else {
      // this.createEmptyAdmsObj(admsObj);
    }
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON;
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.parseObj(value);
      }
    } else {
      this.parseObj(obj);
    }
  }

  parseObj(obj) {
    this.name.parseInputJSON(obj);
    this.selectedType = obj["@type"][0].split("/").pop();
    this.setAdms(obj);
  }


  getExpandedFormatValue() {
    const obj = {};
    const nameExpanded = this.name.getExpandedFormatValue();
    obj[this.name.getNameSpace()] = nameExpanded;

    const admsExpanded = [];
    for (let index = 0; index < this.admsList.length; index++) {
      const admsItem = this.admsList[index];
      admsExpanded.push(admsItem.getExpandedFormatValue());
    }
    obj[this.admsNameSpace] = admsExpanded;
    if (this.selectedType === "Person") {
      obj[assetKeys.type] = [`${keys.person}`];
    } else {
      obj[assetKeys.type] = [`${keys.organization}`];
    }
    return [obj];
  }

  isEmpty() {
    const condition1 = this.name.isEmpty();
    let condition2 = true;
    for (let index = 0; index < this.admsList.length; index++) {
      const admsItem = this.admsList[index];
      condition2 = condition2 && admsItem.isEmpty();
    }
    return condition1 && condition2;
  }
}
